import React, { useEffect, useState } from 'react';
import AdminLayout from './components/adminlayout';
import { serverURL } from '../constants';
import axios from 'axios';
import ContactTable from './components/contacttable';

const Contacts = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
        sessionStorage.setItem('darkMode', false);
        async function fetchData() {
            const response = await axios.get(serverURL + `/api/getcontact`);
            setData(response.data);
        }
        fetchData();
    }, []);

    return (
        <AdminLayout>
            <div className='p-6'>
                <ContactTable datas={data} />
            </div>
        </AdminLayout>
    );
};
export default Contacts;
